'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/breadcrumb/style/css');

var _breadcrumb = require('antd/lib/breadcrumb');

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

var _css2 = require('antd/lib/dropdown/style/css');

var _dropdown = require('antd/lib/dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _css3 = require('antd/lib/icon/style/css');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _css4 = require('antd/lib/layout/style/css');

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRedux = require('react-redux');

var _nav = require('../actions/nav');

var _auth = require('../actions/auth');

var _sidebar_menu = require('./sidebar_menu');

var _sidebar_menu2 = _interopRequireDefault(_sidebar_menu);

var _logout_menu = require('./logout_menu');

var _logout_menu2 = _interopRequireDefault(_logout_menu);

var _product = require('../actions/product');

var _order = require('../actions/order');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 页面整体布局
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var Header = _layout2.default.Header,
    Content = _layout2.default.Content,
    Footer = _layout2.default.Footer,
    Sider = _layout2.default.Sider;

var MainLayout = function (_React$Component) {
  _inherits(MainLayout, _React$Component);

  function MainLayout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MainLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MainLayout.__proto__ || Object.getPrototypeOf(MainLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      collapsed: false
    }, _this.onCollapse = function (collapsed) {

      _this.setState({ collapsed: collapsed });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MainLayout, [{
    key: 'onClick',
    value: function onClick(e) {
      //清除筛选条件
      if (e.key === '1') {
        this.props.dispatch((0, _order.filterOrders)({
          status: -1, date: [], keyword: ''
        }));
      }
      if (e.key === '3') {
        this.props.dispatch((0, _product.filterProducts)({
          status: -1, type: -1, keyword: ''
        }));
      }
      this.props.dispatch((0, _nav.selectMenu)(e.key));
    }
  }, {
    key: 'onLogout',
    value: function onLogout() {
      this.props.dispatch((0, _auth.requestLogout)());
      this.props.router.push('/signin');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _layout2.default,
        { className: 'main-layout' },
        _react2.default.createElement(
          Sider,
          {
            collapsed: this.state.collapsed,
            onCollapse: this.onCollapse
          },
          _react2.default.createElement('div', { className: 'logo' }),
          _react2.default.createElement(_sidebar_menu2.default, { onClick: this.onClick.bind(this), selectedKey: this.props.selectedKey })
        ),
        _react2.default.createElement(
          _layout2.default,
          null,
          _react2.default.createElement(
            Header,
            { className: 'header' },
            _react2.default.createElement(
              'strong',
              null,
              '\u7CD6\u679C\u5370\u8BB0'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                null,
                '\u5E2E\u52A9'
              ),
              _react2.default.createElement(
                _dropdown2.default,
                { overlay: _react2.default.createElement(_logout_menu2.default, { onLogout: this.onLogout.bind(this) }) },
                _react2.default.createElement(
                  'a',
                  { className: 'ant-dropdown-link', href: '#' },
                  this.props.email,
                  _react2.default.createElement(_icon2.default, { type: 'down' })
                )
              )
            )
          ),
          _react2.default.createElement(
            Content,
            { style: { margin: '0 16px' } },
            _react2.default.createElement(_breadcrumb2.default, { style: { margin: '12px 0' } }),
            _react2.default.createElement(
              'div',
              { style: { padding: 24, background: '#fff', minHeight: 360 } },
              this.props.children
            )
          ),
          _react2.default.createElement(
            Footer,
            { style: { textAlign: 'center' } },
            'Crossprint \xA92016'
          )
        )
      );
    }
  }]);

  return MainLayout;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(store) {
  var selectedKey = store.nav.selectedKey;
  var mobile = store.auth.mobile;

  return {
    selectedKey: selectedKey,
    mobile: mobile
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MainLayout);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/main_layout.js
// module id = 918
// module chunks = 0